import NSE_LOGO_BASE64 from "../nseLogoBase64.js";
import { sheetBackLink } from "../sheetNavigation.js";

const SHEET_NAME = "Index";

const LINK_FONT = {
  name: "Calibri",
  size: 11,
  color: { argb: "FF0563C1" },
  underline: true,
};

const internalLink = (row) => sheetBackLink(SHEET_NAME, `D${row}`);
const sheetLink = (sheetName) => sheetBackLink(sheetName, "A1");

const NSE_LOGO_ANCHOR = {
  tl: { col: 9, row: 0 },
  br: { col: 9, row: 5 },
  editAs: "oneCell",
};

const THIN_BORDER = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FF99CCFF" },
};

const TITLE_FONT = { name: "Arial", size: 10, bold: true };
const TOC_NUM_FONT = { name: "Arial", size: 11 };
const SECTION_HEADER_FONT = { name: "Times New Roman", size: 12, bold: true };
const BODY_FONT = { name: "Verdana", size: 10 };
const INDEX_NUM_FONT = { name: "Verdana", size: 10 };
const INDEX_LABEL_FONT = { name: "Verdana", size: 10 };

const COL_FULL_START = 4; // D
const COL_FULL_END = 10; // J
const COL_TOC_NUM = 5; // E
const COL_TOC_LABEL_START = 6; // F
const COL_TOC_LABEL_END = 9; // I
const COL_INDEX_NUM = 4; // D
const COL_INDEX_LABEL_START = 5; // E
const COL_INDEX_LABEL_END = 9; // I
const COL_INDEX_LAST = 10; // J

const TITLE_TEXT =
  "                                      XBRL Excel Utility";

const beforePoints = [
  "1. The version of Microsoft Excel in your system should be Microsoft Office Excel 2007 and above.",
  "2. The system should have a file compression software to unzip excel utility file.",
  "3. Make sure that you have downloaded the latest Excel Utility.",
  "4. Make sure that you have downloaded the Chrome Browser to view report generated from Excel utility",
  "5. Please enable the Macros (if disabled) as per instructions given in manual, so that all the functionalities of  Excel Utility works fine. Please first go through Enable Macro - Manual attached with zip file.",
  '6. Kindly use this file in local system instead of OneDrive/shared drive.\nBecause it may gives an error "Run-time error \'52\' : Bad file name or number" While clicking on textblock button if files saved on OneDrive/shared drive.',
];

/** Index labels (display). Optional `link` maps to an existing workbook sheet. */
const indexSheets = [
  "General Disclosures",
  "Stock exchange",
  { label: "Name of assurance Provider", link: null },
  { label: "Type of assurance obtained", link: null },
  "Details of business activities",
  { label: "Products Services sold", link: "Products services sold" },
  "Holding,subsidiary or associate",
  "Other stakeholder group",
  "Business conduct issues",
  "MGT and process disclosure",
  "PRINCIPLE 1",
  "Penalty or fine",
  "Settlement",
  { label: "Compounding fee", link: "Compounding Fee" },
  "Imprisonment",
  "Punishment",
  { label: "Appeal or revision case details", link: "Appeal or revision case" },
  "Programmes for value chain",
  "PRINCIPLE 2",
  "Life cycle assessment",
  "Action taken",
  "Recycled or reused input",
  "Details of other waste",
  "Reclaimed",
  "PRINCIPLE 3",
  "Other retirement benefits",
  "PRINCIPLE 4",
  "Stakeholder group",
  "PRINCIPLE 5",
  "Other assessments",
  "Details of other value chain",
  "PRINCIPLE 6",
  "Details of other air emissions",
  "Environment approval (clearance)",
  "Environmental impact",
  { label: "Details of non compliance", link: null },
  "Energy consumed from renewable",
  "Energy consumed from NR",
  "Plant in area of water stress",
  "Initiative to improve resource",
  "PRINCIPLE 7",
  "Action taken on issue",
  "Public policy advocates",
  "PRINCIPLE 8",
  "Details of SIA",
  "Details of the benefits from IP",
  "Details of CSR Project",
  { label: "Details of corrective action IP", link: "Details of Corrective Action IP" },
  "Project for rehabilitation",
  "Action to mitigate negative SIA",
  "CSR in aspirational districts",
  { label: "PRINCIPLE  9 ", link: "PRINCIPLE 9" },
];

const fillUpData = [
  "1. Cells with red fonts indicate mandatory fields.",
  "2. If mandatory field is left empty, then Utility will not allow you to proceed further for generating XML.",
  "3. You are not allowed to enter data in the Grey Cells.",
  "4. If fields are not applicable to your company then leave it blank. Do not insert Zero unless it is a mandatory field.",
  "5. Data provided must be in correct format, otherwise Utility will not allow you to proceed further for generating XML.",
  '6. Select data from "Dropdown list" wherever applicable.',
];

const stepsForFiling = [
  {
    text: "I.  Fill up the data: Navigate to each field of every section in the sheet to provide applicable data in correct format.  (Formats will get reflected while filling data.)  \n   - Use paste special command to paste data from other sheet.",
    height: 40,
    vertical: "top",
  },
  {
    text: 'II. Validating Sheets:  Click on the \'\'Validate" button to ensure that the sheet has been properly filled and also data has been furnished in proper format. If there are some errors on the sheet, excel utility will prompt you about the same.',
    height: 30,
    vertical: "middle",
  },
  {
    text: 'III. Validate All Sheets:  Click on the \'\'Home" button. And then click on "Validate All Sheet" button to ensure that all sheets has been properly filled and validated successfully. If there are some errors on the sheet, excel utility will prompt you about the same and stop validation at the same time. After correction, once again follow the same procedure to validate all sheets.',
    height: 40,
    vertical: "middle",
  },
  {
    text: "Excel Utility will not allow you to generate XBRL/XML until you rectify all errors.",
    height: 20.15,
    vertical: "middle",
  },
  {
    text: "IV. Generate XML :   Excel Utility will not allow you to generate XBRL/XML unless successful validation of all sheet is completed. Now click on 'Generate XML'' to generate XBRL/XML file. \n    - Save the XBRL/XML file in your desired folder in local system.",
    height: 40,
    vertical: "middle",
  },
  {
    text: 'V. Generate Report :   Excel Utility will allow you to generate Report. Now click on \'Generate Report\'\' to generate html report.   \n     - Save the HTML Report file in your desired folder in local system.     \n     - To view HTML Report open "Chrome Web Browser" . \n     - To print report in PDF Format, Click on print button and save as PDF.',
    height: 55,
    vertical: "middle",
  },
];

function borderCell(cell) {
  cell.border = THIN_BORDER;
}

function styleCell(cell, { font, align = "left", vertical = "middle", wrap = true, fill = null } = {}) {
  if (font) cell.font = font;
  if (fill) cell.fill = fill;
  cell.alignment = { horizontal: align, vertical, wrapText: wrap };
  borderCell(cell);
}

function mergeFullWidth(ws, row, value, options = {}) {
  const {
    font = BODY_FONT,
    align = "left",
    vertical = "middle",
    wrap = true,
    rowHeight = null,
    fill = null,
  } = options;

  ws.mergeCells(row, COL_FULL_START, row, COL_FULL_END);
  const cell = ws.getCell(row, COL_FULL_START);
  cell.value = value;
  if (font) cell.font = font;
  if (fill) cell.fill = fill;
  cell.alignment = { horizontal: align, vertical, wrapText: wrap };
  cell.border = THIN_BORDER;

  if (rowHeight) ws.getRow(row).height = rowHeight;
}

function addTocRow(ws, row, number, label, anchor) {
  const numCell = ws.getCell(row, COL_TOC_NUM);
  numCell.value = number;
  styleCell(numCell, { font: TOC_NUM_FONT, align: "center", vertical: "middle" });

  ws.mergeCells(row, COL_TOC_LABEL_START, row, COL_TOC_LABEL_END);
  const labelCell = ws.getCell(row, COL_TOC_LABEL_START);
  labelCell.value = { text: label, hyperlink: anchor };
  labelCell.font = LINK_FONT;
  borderCell(labelCell);
  labelCell.alignment = { horizontal: "left", vertical: "middle", wrapText: false };
}

function addIndexSheetRow(ws, row, number, entry) {
  const label = typeof entry === "string" ? entry : entry.label;
  const linkTarget = typeof entry === "string" ? entry : entry.link;

  const numCell = ws.getCell(row, COL_INDEX_NUM);
  numCell.value = number;
  styleCell(numCell, { font: INDEX_NUM_FONT, align: "center", vertical: "middle" });

  ws.mergeCells(row, COL_INDEX_LABEL_START, row, COL_INDEX_LABEL_END);
  const labelCell = ws.getCell(row, COL_INDEX_LABEL_START);
  labelCell.value = label;
  styleCell(labelCell, { font: INDEX_LABEL_FONT, align: "left", vertical: "middle", wrap: false });

  const lastCell = ws.getCell(row, COL_INDEX_LAST);
  if (linkTarget) {
    lastCell.value = { text: label, hyperlink: sheetLink(linkTarget) };
    lastCell.font = LINK_FONT;
  } else {
    lastCell.value = label;
    lastCell.font = LINK_FONT;
  }
  borderCell(lastCell);
  lastCell.alignment = { horizontal: "left", vertical: "middle", wrapText: false };

  ws.getRow(row).height = 18.75;
}

function addBeforePointRow(
  ws,
  row,
  text,
  { rowHeight = 18.75, align = "justify", vertical = "middle", isLast = false } = {}
) {
  ws.mergeCells(row, COL_FULL_START, row, COL_FULL_END);
  const cell = ws.getCell(row, COL_FULL_START);
  cell.value = text;
  cell.font = BODY_FONT;
  cell.alignment = { horizontal: align, vertical, wrapText: true };
  cell.border = {
    left: THIN_BORDER.left,
    right: THIN_BORDER.right,
    ...(isLast ? { bottom: THIN_BORDER.bottom } : {}),
  };

  if (rowHeight) ws.getRow(row).height = rowHeight;
}

function addNseLogo(workbook, worksheet) {
  const imageId = workbook.addImage({
    base64: NSE_LOGO_BASE64,
    extension: "png",
  });
  worksheet.addImage(imageId, NSE_LOGO_ANCHOR);
}

export function buildIndexSheet(workbook) {
  const OVERVIEW_HEADER_ROW = 14;
  const BEFORE_HEADER_ROW = 18;
  const INDEX_HEADER_ROW = 27;
  const INDEX_DATA_START = 28;
  const STEPS_HEADER_ROW = INDEX_DATA_START + indexSheets.length + 2;
  const STEPS_DATA_START = STEPS_HEADER_ROW + 1;
  const FILLUP_HEADER_ROW = STEPS_DATA_START + stepsForFiling.length + 2;
  const FILLUP_DATA_START = FILLUP_HEADER_ROW + 1;

  const ws = workbook.addWorksheet(SHEET_NAME, {
    views: [{ showGridLines: false }],
  });

  // Match NSE Index: only C–L visible; A/B and M→XFD hidden.
  const widths = {
    A: 9.1796875,
    B: 9.1796875,
    C: 9.1796875,
    D: 9.1796875,
    E: 9.1796875,
    F: 9.1796875,
    G: 9.1796875,
    H: 10.26953125,
    I: 40.54296875,
    J: 37.81640625,
    K: 9.1796875,
    L: 9.1796875,
  };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });
  ws.getColumn("A").hidden = true;
  ws.getColumn("B").hidden = true;
  for (let col = 13; col <= 16384; col += 1) {
    const column = ws.getColumn(col);
    column.width = 9.1796875;
    column.hidden = true;
  }

  ws.mergeCells(6, COL_TOC_NUM, 6, COL_TOC_LABEL_END);
  const titleCell = ws.getCell(6, COL_TOC_NUM);
  titleCell.value = TITLE_TEXT;
  styleCell(titleCell, { font: TITLE_FONT, vertical: "middle", fill: HEADER_FILL });
  ws.getRow(6).height = 15;

  const tocRows = [
    { number: "1.", label: "Overview", anchor: internalLink(OVERVIEW_HEADER_ROW) },
    { number: "2.", label: "Before you begin", anchor: internalLink(BEFORE_HEADER_ROW) },
    { number: "3.", label: "Index", anchor: internalLink(INDEX_HEADER_ROW) },
    {
      number: "4.",
      label: "Steps for Filing Business Responsibility & Sustainability Reporting",
      anchor: internalLink(STEPS_HEADER_ROW),
    },
    { number: "5.", label: "Fill up the data in excel utility", anchor: internalLink(FILLUP_HEADER_ROW) },
  ];
  tocRows.forEach(({ number, label, anchor }, idx) => {
    addTocRow(ws, 7 + idx, number, label, anchor);
  });

  mergeFullWidth(ws, OVERVIEW_HEADER_ROW, "1. Overview", {
    font: SECTION_HEADER_FONT,
    align: "center",
    rowHeight: 15,
    fill: HEADER_FILL,
  });
  mergeFullWidth(ws, OVERVIEW_HEADER_ROW + 1, "The excel utility can be used for creating the XBRL/XML file for efiling of Business Responsibility & Sustainability Report", {
    align: "justify",
  });

  mergeFullWidth(ws, BEFORE_HEADER_ROW, " 2.  Before you begin", {
    font: SECTION_HEADER_FONT,
    align: "center",
    rowHeight: 15,
    fill: HEADER_FILL,
  });
  const beforePointStyles = [
    { rowHeight: 18.75 },
    { rowHeight: 18.75, align: "left" },
    { rowHeight: 18.75 },
    { rowHeight: 18.75 },
    { rowHeight: 33.75 },
    { rowHeight: 40, align: "left", vertical: "top" },
  ];
  beforePoints.forEach((text, idx) => {
    addBeforePointRow(ws, BEFORE_HEADER_ROW + 1 + idx, text, {
      ...beforePointStyles[idx],
      isLast: idx === beforePoints.length - 1,
    });
  });

  mergeFullWidth(ws, INDEX_HEADER_ROW, "3. Index ", {
    font: SECTION_HEADER_FONT,
    align: "center",
    wrap: false,
    rowHeight: 15,
    fill: HEADER_FILL,
  });
  indexSheets.forEach((sheetName, idx) => {
    addIndexSheetRow(ws, INDEX_DATA_START + idx, idx + 1, sheetName);
  });

  mergeFullWidth(
    ws,
    STEPS_HEADER_ROW,
    "4. Steps for Filing Business Responsibility & Sustainability Reporting",
    { font: SECTION_HEADER_FONT, align: "center", rowHeight: 15, fill: HEADER_FILL }
  );
  stepsForFiling.forEach((step, idx) => {
    mergeFullWidth(ws, STEPS_DATA_START + idx, step.text, {
      align: "justify",
      vertical: step.vertical,
      rowHeight: step.height,
    });
  });

  mergeFullWidth(ws, FILLUP_HEADER_ROW, "5. Fill up the data in excel utility", {
    font: SECTION_HEADER_FONT,
    align: "center",
    wrap: false,
    rowHeight: 15,
    fill: HEADER_FILL,
  });
  fillUpData.forEach((text, idx) => {
    mergeFullWidth(ws, FILLUP_DATA_START + idx, text, {
      align: "justify",
      rowHeight: 18.75,
    });
  });

  addNseLogo(workbook, ws);

  return ws;
}
